export default __webpack_public_path__ + "static/media/JustineOMahoney.31cc461f.webp";